import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DetailView from '../Common/DetailView';
import { CategoryLevel } from './CategoryLevel';
import CancelIcon from 'material-ui/svg-icons/navigation/cancel';

import CategoryActions from '../../actions/CategoryActionCreator';
import CategoryStore from '../../stores/CategoryStore';

import buildContextMenu from '../Common/BuildContextMenu';
import { Card, CardHeader, CardText } from 'material-ui/Card';

class CategoryTree extends Component {

    constructor() {
        super(...arguments);
        this.state = {
            categories: [],
            actions: buildContextMenu(this.getActions(), this.context.auth),
        };
    }

    componentDidMount() {
        this.onCategoryChange = this.onCategoryChange.bind(this);
        this.listeners = [
            CategoryStore.addListener(this.onCategoryChange),
        ];
        CategoryActions.getAllWithCount();
    }

    componentWillUnmount() {
        this.listeners.forEach(listener => listener.remove());
    }
    
    getActions() {
        return [
            {
                link: '/logout',
                icon: <CancelIcon />,
                label: 'Sign out',
            }
        ];
    }

    render() {
        const newEntityUrl = this.context.auth.isAdmin() ? '/dashboard/category/new' : null;
        return (
            <DetailView
                title="Library"
                newEntityUrl={newEntityUrl}
                actions={this.state.actions}
            >
                <div className="cent-cards">
                    <Card className="cent-card" >
                        <CardHeader
                            title='Categories'
                        />
                        <CardText className="cent-card-text">
                            {this.state.categories.length > 0 && (
                                <CategoryLevel nodes={this.state.categories}/>
                            )}
                        </CardText>
                    </Card>
                </div>
            </DetailView>
       );
    }
    
    onCategoryChange() {
        const categories = CategoryStore.getTree();
        if (categories) {
            this.setState({categories});
        }
    }
}

CategoryTree.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default CategoryTree;
